/**
 * Builds a list of codes for export from a flat, pre-sorted array
 * @param {Array} codesData - Flat array of codes already in the correct order from useCodeSidebarCodes (or equivalent)
 *                            Each code must have: id, name, level, and optionally: count, synthesis, url
 * @returns {Array} Export-formatted list: [id, order_number, depth_indicator, name, count, synthesis, url]
 */
export function buildCodeList(codesData) {
  if (!codesData || !Array.isArray(codesData)) return [];

  // This expects a flat list already in the correct order from useCodeSidebarCodes (or equivalent)
  // We simply map it to the export format without any re-sorting or re-structuring

  return codesData.map((code, index) => {
    // Format: [id, order_number, depth_indicator, name, count, synthesis, url]
    return [
      code.id,
      index + 1, // Order number (1-based)
      '>'.repeat(code.level || 1), // Depth indicator based on level
      code.name,
      code.count || 0,
      code.synthesis || '',
      code.url || ''
    ];
  });
}